window.Lit = 
  name: '名称'
  alias: '简称'
  des: '说明'
  confirm: '确定'
  cancel: '取消'
  submit: '提交'
  link: '链接'
  refresh: '刷新'
  show: '显示'
  hide: '隐藏'
  detail: '详细'
  back: '返回'
  change: '修改'
  title: '标题'
  save: '保存'
  index: '首页'
  explore: '浏览'
